(function () {
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  // Generic slider: track, slides, dots, prev/next, optional touch swipe
  function slider(track, count, dots, prev, next, activeCls) {
    var i = 0;
    function go(n) {
      i = (n + count) % count;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle(activeCls, k === i); });
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // In-product review carousel
    qsa('.sb-reviews').forEach(function (w) {
      var track = qs('.sb-reviews-track', w), n = qsa('.sb-review-card', w).length;
      if (n > 1) slider(track, n, qsa('.sb-dot', w), null, null, 'sb-dot--active');
    });
    // Gif review carousel
    qsa('.sb-rev').forEach(function (w) {
      var track = qs('.sb-rev-track', w), n = qsa('.sb-rev-slide', w).length;
      if (n > 1) slider(track, n, qsa('.sb-rev-dot', w), qs('.sb-rev-arrow:not(.sb-rev-arrow--filled)', w), qs('.sb-rev-arrow--filled', w), 'is-active');
    });
    // FAQ accordions
    qsa('.sbFaq1-q, .sbFaq2-q').forEach(function (b) {
      b.addEventListener('click', function () { b.parentNode.classList.toggle('open'); });
    });
    // CTA scroll to buy box
    qsa('.sb-cta-scroll-bundle[data-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = qs('#ProductForm') || qs('.product-info');
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    });

    // Product form: variants, bundles, price
    var form = qs('#ProductForm'), data = qs('#ProductJSON');
    if (form && data) {
      var product = JSON.parse(data.textContent);
      var idInput = qs('#VariantId'), qtyInput = qs('#Quantity');
      var btns = qsa('[data-atc]');
      function currentOptions() {
        return qsa('.sb-opt', form).map(function (fs) { var c = qs('input:checked', fs); return c ? c.value : null; });
      }
      function variant() {
        var o = currentOptions();
        if (!o.length) return product.variants[0];
        return product.variants.find(function (v) { return v.options.every(function (x, i) { return x === o[i]; }); });
      }
      function updatePrices(v) {
        var unit = v.price, cmp = v.compare_at_price || 0;
        qsa('.mb-offer', form).forEach(function (o) {
          var q = +o.dataset.qty, disc = +o.dataset.discount || 0;
          var total = Math.round(unit * q * (100 - disc) / 100);
          var was = Math.round((cmp > unit ? cmp : unit) * q);
          var p = qs('.mb-price-now', o), s = qs('.mb-price-was', o);
          if (p) p.textContent = window.sbMoney(total);
          if (s) s.textContent = was > total ? window.sbMoney(was) : '';
        });
      }
      window.sbMoney = window.sbMoney || function (c) { return (window.sbCurrency || '$') + (c / 100).toFixed(2); };
      function onChange() {
        var v = variant();
        if (!v) { btns.forEach(function (b) { b.disabled = true; }); return; }
        idInput.value = v.id;
        btns.forEach(function (b) {
          b.disabled = !v.available;
          var l = qs('[data-atc-label]', b) || b;
          l.textContent = v.available ? b.dataset.atc : b.dataset.soldout;
        });
        updatePrices(v);
        var url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
      form.addEventListener('change', function (e) {
        if (e.target.name === 'bundle') {
          qsa('.mb-offer', form).forEach(function (o) { o.classList.toggle('is-selected', qs('input', o).checked); });
          qtyInput.value = e.target.dataset.qty;
        }
        onChange();
      });
      var first = qs('.mb-offer input:checked', form);
      if (first) { qtyInput.value = first.dataset.qty; first.closest('.mb-offer').classList.add('is-selected'); }
      onChange();

      // Sticky bar
      var sticky = qs('.sb-sticky'), main = qs('[data-atc]', form);
      if (sticky && main && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(main);
        qs('[data-atc]', sticky).addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      }
    }

    // Size modal + calculator
    var ov = qs('.sbz-overlay');
    if (ov) {
      var trig = qs('.sbz-trigger');
      function open() { ov.hidden = false; document.body.style.overflow = 'hidden'; }
      function close() { ov.hidden = true; document.body.style.overflow = ''; }
      trig.addEventListener('click', open);
      qs('.sbz-close', ov).addEventListener('click', close);
      ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
      qsa('.sbz-tab', ov).forEach(function (t) {
        t.addEventListener('click', function () {
          qsa('.sbz-tab', ov).forEach(function (x) { x.classList.toggle('is-active', x === t); });
          qsa('.sbz-pane', ov).forEach(function (p) { p.classList.toggle('is-active', p.id === t.dataset.pane); });
        });
      });
      var unit = 'cm', suffix = qs('.sbz-suffix', ov), input = qs('.sbz-input', ov);
      qsa('.sbz-u', ov).forEach(function (u) {
        u.addEventListener('click', function () {
          unit = u.dataset.unit; suffix.textContent = unit;
          qsa('.sbz-u', ov).forEach(function (x) { x.classList.toggle('is-active', x === u); });
        });
      });
      var rows = qsa('.sbz-table tbody tr', ov).map(function (r) {
        var c = r.children; return { size: c[0].textContent.trim(), min: +c[1].dataset.min, max: +c[2].dataset.max, us: c[3] ? c[3].textContent.trim() : '' };
      });
      qs('.sbz-calc', ov).addEventListener('click', function () {
        var w = parseFloat(input.value), err = qs('.sbz-error', ov), res = qs('.sbz-result', ov);
        if (!w || w <= 0) { err.textContent = 'Please enter your waist measurement.'; err.hidden = false; res.hidden = true; return; }
        if (unit === 'in') w = w * 2.54;
        var hit = rows.find(function (r) { return w >= r.min && w <= r.max; });
        if (!hit) hit = w < rows[0].min ? rows[0] : rows[rows.length - 1];
        err.hidden = true; res.hidden = false;
        qs('.sz', res).textContent = hit.size; qs('.us', res).textContent = hit.us;
        var radio = qsa('.sb-opt input', form || document).find(function (r) { return r.value.toLowerCase() === hit.size.toLowerCase(); });
        if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      var cta = qs('.sbz-cta', ov);
      if (cta) cta.addEventListener('click', close);
    }
  });
})();
